import get from 'lodash/fp/get';
import pipe from 'lodash/fp/pipe';

const getScroll = get('scroll');

export const getScrollData = (state, key) => pipe(
  getScroll,
  get(key)
)(state)